export default class StatusComponenteConstant {
    static PENDENTE = {
        chave: 'pendente',
        nome: 'Pendente'
    }
    static NAO_PREENCHIDO = {
        chave: 'nao-preenchido',
        nome: 'Não Preenchido'
    }
    static PREENCHIDO = {
        chave: 'preenchido',
        nome: 'Preenchido'
    }
}